
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spare-shops-near-me",
      function () {
        return require("private-next-pages/spare-shops-near-me/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spare-shops-near-me"])
      });
    }
  